import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { AnimatePresence, motion } from 'framer-motion'
import {
  Input,
  Textarea,
  Typography,
  IconButton,
} from "@material-tailwind/react";
import { Eye, EyeClosed } from "iconoir-react";

import { findInputError, isFormInvalid } from '../utils'
import { framer_error } from '../utils/inputValidations'

interface FormInputProps {
    id: string;
    type: string;
    name: string;
    label: string;
    validation: any;
    wrapperClass: string;
    inputClass: string;
    placeholder: string;
    multiline?: boolean;
    labelClass?: string;
    labelColor?: string;
}

const FormInputValidation: React.FC<FormInputProps> = ({
    name,
    label,
    type,
    id,
    placeholder,
    inputClass,
    wrapperClass,
    multiline,
    validation,
    labelClass,
    labelColor,
}) => {
    const {
        register,
        formState: { errors },
    } = useFormContext()

    const [inputType, setInputType] = useState("password");
    const inputErrors = findInputError(errors, name)
    const isInvalid = isFormInvalid(inputErrors)

    return (
        <div className={wrapperClass}>
            <div className="flex justify-between">
                { label ?
                    <Typography
                        as="label"
                        htmlFor={id}
                        type="small"
                        color="default"
                        className={`${labelClass ? labelColor : 'font-semibold'} ${isInvalid ? 'text-red-500' : (labelColor ? labelColor : 'text-black')}`}
                    >
                        {label}
                    </Typography>
                    : null
                }
                <AnimatePresence mode="wait" initial={false}>
                    {isInvalid && (
                        <motion.p
                            className="flex items-center gap-1 py-1 mb-1 px-2 font-semibold text-red-500 bg-red-100 rounded-md"
                            {...framer_error}
                        >
                            {inputErrors.error.message}
                        </motion.p>
                    )}
                </AnimatePresence>
            </div>
            {multiline
                ? <Textarea
                        rows={8}
                        placeholder={placeholder}
                        className={`${inputClass} ${isInvalid ? 'border-red-300 focus:ring-0 focus:outline-none focus:border-red-500' : ''}`}
                        {...register(name, validation)}
                    />
                : <Input
                      size="lg"
                      id={id}
                      type={type}
                      placeholder={placeholder}
                      className={`${inputClass} ${isInvalid ? 'border-red-300 focus:ring-0 focus:outline-none focus:border-red-500' : ''}`}
                      {...register(name, validation)}
                   >
                       { type !== "password"
                           ? null
                           : <Input.Icon
                                as={IconButton}
                                type="button"
                                variant="ghost"
                                placement="end"
                                color="secondary"
                                className="data-[placement=end]:right-1.5 !absolute select-auto z-10 pointer-events-auto"
                                onClick={() =>
                                    setInputType(inputType === "password" ? "text" : "password")
                                }
                             >
                                {
                                    inputType === "password"
                                    ? <EyeClosed className="h-6 w-6" />
                                    : <Eye className="h-6 w-6" />
                                }
                             </Input.Icon>
                       }
                  </Input>
             }
        </div>
    )
}

export default FormInputValidation;
